export default "__VITE_ASSET__mr8nw93T__"